module.exports = __webpack_public_path__ + "static/img/SFU老师_俊哥.354f34c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/SFU/SFU老师_俊哥.png
// module id = UxvQ
// module chunks = 0